<template>
  <div class="content-main">
    <div class="content-title">
      <span class="total">
        {{lan.c_total}}
        <span class="num">{{rong.total}}</span>
        {{lan.c_records}}
      </span>
      <!-- <span class="time">2019年06月05日</span> -->
    </div>
    <ul class="content" id="historycontent">
      <li v-for="(item,index) in contentlist" :key="index" v-show="item.txt" class="content-li">
        <span class="time">{{item.showTime}}</span>
        <div style="display:flex">
          <div class="headurl">
            <HeadUrl :itcode="item.userId" class="head" />
          </div>
          <div class="txt">
            <span
              style="font-size:10px"
              :class="login.userInfo.itcode == item.userId ?'name':''"
            >{{item.userId}}</span>
            <span style="font-size:10px">{{item.sendTime}}</span>
            <span v-text="item.txt" class="html"></span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapMutations, mapState, mapGetters } from "vuex";
import HeadUrl from "../headurl/index";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["rong", "login"]),
    ...mapGetters({ contentlist: "rong/contentlist", lan: "common/lan" })
  },
  watch: {
    contentlist: "scrollToBottom"
  },
  components: {
    HeadUrl
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        var div = document.getElementById("historycontent");
        div.scrollTop = div.scrollHeight;
        // console.log(div.scrollTop,div.scrollHeight)
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content-main {
  padding-top: 21px;
  padding-left: 75px;
  padding-right: 30px;
  .content-title {
    margin-bottom: 10px;
    .total {
      font-size: 10px;
      font-family: PingFangSC;
      color: rgba(51, 51, 51, 1);
    }
    .num {
      font-size: 10px;
      font-family: PingFangSC;
      color: rgba(37, 182, 237, 1);
    }
  }

  .content {
    padding-top: 20px;
    overflow-y: auto;
    height: 410px;
    .content-li {
      display: flex;
      margin-bottom: 21px;
      flex-direction: column;
      .time {
        // display: block;
        font-size: 10px;
        font-family: PingFangSC;
        color: rgba(51, 51, 51, 1);
        padding-bottom: 10px;
      }
      .headurl {
        // display: inline-block;
        //  margin-bottom: 20px;
        padding-top: 7px;
        .head {
          width: 25px;
          height: 25px;
          border-radius: 1px;
          margin-right: 15px;
        }
        // border: 1px solid black;
      }
      .txt {
        font-family: PingFangSC;
        // display: inline-block;
        .name {
          color: rgba(37, 182, 237, 1);
        }
        .html {
          font-size: 16px;
          font-family: PingFangSC;
          color: rgba(58, 58, 58, 1);
          display: block;
          width: 900px;
          font-variant-ligatures: no-common-ligatures; //fi分开
          word-wrap: break-word;
          word-break: break-word;
        }
      }
    }
  }

  // .content {
  //   padding-top: 20px;
  //   overflow-y: auto;
  //   height: 410px;
  //   .content-li {
  //     // display: flex;
  //     margin-bottom: 20px;
  //     // vertical-align: top;
  //     .time {
  //       display: block;
  //       font-size: 10px;
  //       font-family: PingFangSC;
  //       color: rgba(51, 51, 51, 1);
  //       // padding-top: 10px;
  //       padding-bottom: 10px;
  //     }
  //     .headurl {
  //       display: inline-block;
  //        margin-bottom: 8px;
  //       .head {
  //         width: 25px;
  //         height: 25px;
  //         border-radius: 1px;
  //         margin-right: 15px;
  //       }
  //       // border: 1px solid black;
  //     }
  //     .txt {
  //       display: inline-block;
  //       .html {
  //         font-size: 13px;
  //         font-family: PingFangSC;
  //         color: rgba(58, 58, 58, 1);
  //         display: block;
  //         width: 900px;
  //         padding-top: 6px;
  //         font-variant-ligatures: no-common-ligatures; //fi分开
  //         word-wrap: break-word;
  //         word-break: break-word;
  //       }
  //       .name {
  //         color: rgba(37, 182, 237, 1);
  //       }
  //     }
  //   }
  // }
  .content::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    // scrollbar-arrow-color:red;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/rong/HistoryContent.vue